// extracted by mini-css-extract-plugin
export default {"contest":"styles_contest__lj0Zn"};